import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useSettings } from '../../contexts/SettingsContext';
import {
  Typography, Box, Card, CardContent, Grid, Button, Table, TableBody, 
  TableCell, TableContainer, TableHead, TableRow, Chip, Avatar,
  FormControl, InputLabel, Select, MenuItem, Dialog, DialogTitle,
  DialogContent, DialogActions, Tabs, Tab, LinearProgress, Divider,
  List, ListItem, ListItemText, ListItemAvatar, IconButton, Tooltip,
  Alert, Stack, Paper, Accordion, AccordionSummary, AccordionDetails,
  TextField, Autocomplete, AvatarGroup, Badge, Fab, CardHeader,
  CardActions, Stepper, Step, StepLabel, StepContent, Rating,
  CircularProgress, useTheme, useMediaQuery, Grow, Skeleton
} from '@mui/material';
import {
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  Assessment as AssessmentIcon,
  MonetizationOn as MonetizationOnIcon,
  People as PeopleIcon,
  Flight as FlightIcon,
  DateRange as DateRangeIcon,
  FileDownload as FileDownloadIcon,
  RocketLaunch,
  AutoAwesome,
  Diamond,
  Visibility as VisibilityIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
  Timeline as TimelineIcon,
  Business as BusinessIcon,

  LocationOn as LocationOnIcon,
  Link as LinkIcon,
  Check as CheckIcon,
  Analytics as AnalyticsIcon,
  DonutLarge as DonutLargeIcon,
  ShowChart as ShowChartIcon,
  Dashboard as DashboardIcon,
  FilterList as FilterListIcon,
  Compare as CompareIcon,
  Refresh as RefreshIcon,
  Share as ShareIcon,
  Print as PrintIcon,
  Email as EmailIcon,
  ExpandMore as ExpandMoreIcon,
  Info as InfoIcon,
  Warning as WarningIcon,
  Assignment as AssignmentIcon,
  EventNote as EventNoteIcon,
  CalendarToday as CalendarTodayIcon,
  Schedule as ScheduleIcon,
  AccountBalance as AccountBalanceIcon,
  PersonAdd as PersonAddIcon,
  WorkspacePremium as WorkspacePremiumIcon,
  AttachMoney as AttachMoneyIcon,
  Group as GroupIcon,
  Place as PlaceIcon,
  Hotel as HotelIcon,
  RestaurantMenu as RestaurantMenuIcon,
  LocalActivity as LocalActivityIcon,
  DirectionsBus as DirectionsBusIcon,
  Insights as InsightsIcon,
  Speed as SpeedIcon,
  TrendingFlat as TrendingFlatIcon,
  Map as MapIcon,
  Language as LanguageIcon,
  Security as SecurityIcon,
  Psychology as PsychologyIcon,
  CreditCard as CreditCardIcon,
  Receipt as ReceiptIcon,
  Payment as PaymentIcon,
  Savings as SavingsIcon,
  AccountBalanceWallet as WalletIcon,
  TrendingNeutral as TrendingNeutralIcon,
  ArrowForward as ArrowForwardIcon,
  Launch as LaunchIcon,
  OpenInNew as OpenInNewIcon,
  NavigateNext as NavigateNextIcon,
  ChevronRight as ChevronRightIcon,
  Explore as ExploreIcon,
  TravelExplore as TravelExploreIcon,
  FlightTakeoff as FlightTakeoffIcon,
  FlightLand as FlightLandIcon,
  LocalAirport as LocalAirportIcon,
  AirplanemodeActive as AirplanemodeActiveIcon,
  Loyalty as LoyaltyIcon,
  Stars as StarsIcon,
  Grade as GradeIcon,
  EmojiEvents as EmojiEventsIcon,
  Leaderboard as LeaderboardIcon,
  Equalizer as EqualizerIcon,
  MultilineChart as MultilineChartIcon,
  ScatterPlot as ScatterPlotIcon,
  BubbleChart as BubbleChartIcon,
  CandlestickChart as CandlestickChartIcon,
  StackedLineChart as StackedLineChartIcon,
  AutoGraph as AutoGraphIcon,
  DataUsage as DataUsageIcon,
  QueryStats as QueryStatsIcon,
  Lightbulb as LightbulbIcon,
  RecommendOutlined as RecommendOutlinedIcon,
  TipsAndUpdates as TipsAndUpdatesIcon,
  Verified as VerifiedIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Pending as PendingIcon,
  Error as ErrorIcon,
  HelpOutline as HelpOutlineIcon,
  Feedback as FeedbackIcon,
  ThumbUp as ThumbUpIcon,
  ThumbDown as ThumbDownIcon,
  SentimentVeryDissatisfied as SentimentVeryDissatisfiedIcon,
  SentimentDissatisfied as SentimentDissatisfiedIcon,
  SentimentNeutral as SentimentNeutralIcon,
  SentimentSatisfied as SentimentSatisfiedIcon,
  SentimentVerySatisfied as SentimentVerySatisfiedIcon,
  Public as PublicIcon,
  Language as LanguageIcon2,
  Translate as TranslateIcon,
  RecordVoiceOver as RecordVoiceOverIcon,
  Support as SupportIcon,
  ContactSupport as ContactSupportIcon,
  LiveHelp as LiveHelpIcon,
  Chat as ChatIcon,
  Message as MessageIcon,
  Forum as ForumIcon,
  Comment as CommentIcon,
  QuestionAnswer as QuestionAnswerIcon,
  Announcement as AnnouncementIcon,
  Campaign as CampaignIcon,
  Notifications as NotificationsIcon,
  NotificationImportant as NotificationImportantIcon,
  NotificationsActive as NotificationsActiveIcon,
  Update as UpdateIcon,
  NewReleases as NewReleasesIcon,
  Fiber as FiberIcon,
  FiberNew as FiberNewIcon,
  FiberManualRecord as FiberManualRecordIcon,
  FiberSmartRecord as FiberSmartRecordIcon,
  RadioButtonChecked as RadioButtonCheckedIcon,
  RadioButtonUnchecked as RadioButtonUncheckedIcon,
  ToggleOn as ToggleOnIcon,
  ToggleOff as ToggleOffIcon,
  PowerSettingsNew as PowerSettingsNewIcon,
  Power as PowerIcon,
  PowerOff as PowerOffIcon,
  Settings as SettingsIcon,
  SettingsApplications as SettingsApplicationsIcon,
  SettingsBackupRestore as SettingsBackupRestoreIcon,
  SettingsBrightness as SettingsBrightnessIcon,
  SettingsCell as SettingsCellIcon,
  SettingsEthernet as SettingsEthernetIcon,
  SettingsInputAntenna as SettingsInputAntennaIcon,
  SettingsInputComponent as SettingsInputComponentIcon,
  SettingsInputComposite as SettingsInputCompositeIcon,
  SettingsInputHdmi as SettingsInputHdmiIcon,
  SettingsInputSvideo as SettingsInputSvideoIcon,
  SettingsOverscan as SettingsOverscanIcon,
  SettingsPhone as SettingsPhoneIcon,
  SettingsPower as SettingsPowerIcon,
  SettingsRemote as SettingsRemoteIcon,
  SettingsSystemDaydream as SettingsSystemDaydreamIcon,
  SettingsVoice as SettingsVoiceIcon,
  Tune as TuneIcon,
  Build as BuildIcon,
  Construction as ConstructionIcon,
  Engineering as EngineeringIcon,
  Handyman as HandymanIcon,
  HomeRepairService as HomeRepairServiceIcon,
  MiscellaneousServices as MiscellaneousServicesIcon,
  RoomService as RoomServiceIcon,
  CarRepair as CarRepairIcon,
  LocalCarWash as LocalCarWashIcon,
  LocalGasStation as LocalGasStationIcon,
  LocalParking as LocalParkingIcon,
  LocalShipping as LocalShippingIcon,
  LocalTaxi as LocalTaxiIcon,
  DirectionsCar as DirectionsCarIcon,
  DirectionsBike as DirectionsBikeIcon,
  DirectionsBoat as DirectionsBoatIcon,
  DirectionsRailway as DirectionsRailwayIcon,
  DirectionsRun as DirectionsRunIcon,
  DirectionsSubway as DirectionsSubwayIcon,
  DirectionsTransit as DirectionsTransitIcon,
  DirectionsWalk as DirectionsWalkIcon,
  Train as TrainIcon,
  Subway as SubwayIcon,
  Tram as TramIcon,
  AirplanemodeInactive as AirplanemodeInactiveIcon,
  Luggage as LuggageIcon,
  BusinessCenter as BusinessCenterIcon,
  Work as WorkIcon,
  WorkOutline as WorkOutlineIcon,
  WorkOff as WorkOffIcon,
  WorkHistory as WorkHistoryIcon,
  Assignment as AssignmentIcon2,
  AssignmentInd as AssignmentIndIcon,
  AssignmentLate as AssignmentLateIcon,
  AssignmentReturn as AssignmentReturnIcon,
  AssignmentReturned as AssignmentReturnedIcon,
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  Task as TaskIcon,
  TaskAlt as TaskAltIcon,
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  IndeterminateCheckBox as IndeterminateCheckBoxIcon,
  Switch as SwitchIcon,
  ShoppingCart as ShoppingCartIcon
} from '@mui/icons-material';

// Import all necessary data hooks
import { 
  useReservationsData, 
  useClientsData, 
  usePackagesData, 
  useFinancialData,
  useDashboardData,
  useDocumentsData,
  useSuppliersData,
  useSidebarCounts
} from '../../services/dataService';

// Import our new reports service
import {
  useReportsData,
  useClientsReportData,
  useFinancesReportData,
  useReservationsReportData,
  exportReport
} from '../../services/reportsService';

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';

// FloatingActionCard component from Dashboard
const FloatingActionCard = ({ title, icon, color, action, description, badge, onClick }) => {
  // Get theme and check if mobile
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Card sx={{
      background: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(20px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      borderRadius: { xs: 3, md: 4 },
      overflow: 'hidden',
      position: 'relative',
      cursor: 'pointer',
      height: '100%',
      transition: 'all 0.3s ease',
      '&:hover': {
        transform: 'translateY(-5px)',
        background: 'rgba(255, 255, 255, 0.15)',
        boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
      }
    }} onClick={onClick}>
      <CardContent sx={{ 
        p: { xs: 2, sm: 2.5, md: 3 }, 
        position: 'relative', 
        zIndex: 1,
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: { xs: 1, md: 2 }, 
          mb: { xs: 1.5, md: 2 },
          flexWrap: 'wrap'
        }}>
          <Avatar className="action-icon" sx={{ 
            bgcolor: 'rgba(255,255,255,0.2)',
            color: 'white',
            width: { xs: 48, sm: 52, md: 56 },
            height: { xs: 48, sm: 52, md: 56 },
            boxShadow: '0 8px 25px rgba(0,0,0,0.2)',
            '& .MuiSvgIcon-root': {
              fontSize: { xs: 26, sm: 28, md: 30 }
            }
          }}>
            {icon}
          </Avatar>
          {badge && (
            <Chip 
              label={badge} 
              size="small" 
              sx={{ 
                background: 'rgba(255, 255, 255, 0.2)',
                color: 'white',
                fontWeight: 600,
                height: { xs: '20px', md: '24px' },
                fontSize: { xs: '0.7rem', md: '0.75rem' }
              }}
            />
          )}
        </Box>
        <Typography 
          variant="h6" 
          sx={{ 
            fontWeight: 700, 
            mb: { xs: 0.5, md: 1 }, 
            color: 'white',
            lineHeight: 1.3,
            fontSize: { xs: '1.1rem', sm: '1.2rem', md: '1.3rem' }
          }}
        >
          {title}
        </Typography>
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: { xs: '0.75rem', md: '0.875rem' },
            display: { xs: '-webkit-box', md: 'block' },
            WebkitLineClamp: { xs: 2, md: 'none' },
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
};

// EnhancedStatCard from Dashboard
const EnhancedStatCard = ({ title, value, icon, gradient, delay, onClick, subtitle, chart, trend, progress }) => (
  <Grow in={true} style={{ transformOrigin: '0 0 0' }} timeout={1000}>
    <Card
      onClick={onClick}
      sx={{
        height: '100%',
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        color: 'white',
        borderRadius: 3,
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        transition: 'transform 0.3s, box-shadow 0.3s',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick ? {
          transform: 'translateY(-5px)',
          background: 'rgba(255, 255, 255, 0.15)',
          boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
        } : {},
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CardContent sx={{ flexGrow: 1, p: { xs: 2, md: 3 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Box>
            <Typography variant="body2" sx={{ 
              color: 'rgba(255, 255, 255, 0.7)', 
              mb: 0.5, 
              fontWeight: 500,
              fontSize: { xs: '0.8rem', md: '0.875rem' }
            }}>
              {title}
            </Typography>
            <Typography variant="h5" sx={{ 
              fontWeight: 700,
              fontSize: { xs: '1.5rem', md: '1.75rem' },
              color: 'white'
            }}>
              {value}
            </Typography>
            {subtitle && (
              <Typography variant="body2" sx={{ 
                color: 'rgba(255, 255, 255, 0.7)', 
                mt: 0.5,
                fontSize: { xs: '0.75rem', md: '0.875rem' }
              }}>
                {subtitle}
              </Typography>
            )}
            {trend && (
              <Chip 
                label={trend} 
                size="small" 
                sx={{ 
                  mt: 1,
                  backgroundColor: trend.startsWith('+') ? 
                    'rgba(16, 185, 129, 0.3)' : 
                    'rgba(239, 68, 68, 0.3)',
                  color: 'white',
                  fontWeight: 600,
                  fontSize: { xs: '0.65rem', md: '0.75rem' },
                  height: { xs: 20, md: 24 }
                }}
              />
            )}
          </Box>
          <Avatar
            sx={{
              bgcolor: 'rgba(255,255,255,0.2)',
              color: 'white',
              width: { xs: 40, md: 48 },
              height: { xs: 40, md: 48 }
            }}
          >
            {icon}
          </Avatar>
        </Box>
        
        {progress && (
          <Box sx={{ mt: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
              <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                Progression
              </Typography>
              <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                {progress}%
              </Typography>
            </Box>
            <LinearProgress 
              variant="determinate" 
              value={progress} 
              sx={{ 
                height: 6, 
                borderRadius: 3,
                backgroundColor: 'rgba(255,255,255,0.2)',
                '& .MuiLinearProgress-bar': {
                  backgroundColor: 'white',
                }
              }} 
            />
          </Box>
        )}
        
        {chart && (
          <Box sx={{ mt: 2, height: { xs: 40, md: 60 } }}>
            {chart}
          </Box>
        )}
      </CardContent>
    </Card>
  </Grow>
);

// Enhanced Chart Components with more interactive features
const AdvancedRevenueChart = ({ data, title, formatCurrency }) => {
  const maxValue = Math.max(...data.map(item => item.montant));
  const [hoveredBar, setHoveredBar] = useState(null);
  
  return (
    <Grow in={true} style={{ transformOrigin: '0 0 0' }} timeout={800}>
      <Card sx={{ 
        mb: 3, 
        borderRadius: 3,
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        overflow: 'hidden'
      }}>
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
            <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white', width: 48, height: 48 }}>
              <ShowChartIcon />
            </Avatar>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5, color: 'white' }}>
                {title}
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                Analyse des tendances par période
              </Typography>
            </Box>
          </Box>
        <Box sx={{ height: 350, position: 'relative', mt: 2 }}>
          {/* Chart bars */}
          <Box sx={{ height: 280, display: 'flex', alignItems: 'end', gap: { xs: 0.5, md: 1 } }}>
            {data.map((item, index) => (
              <Box key={index} sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Tooltip title={`${item.mois}: ${formatCurrency(item.montant)} • ${item.reservations} réservations`}>
                  <Box
                    onMouseEnter={() => setHoveredBar(index)}
                    onMouseLeave={() => setHoveredBar(null)}
                    sx={{
                      width: '100%',
                      height: `${(item.montant / maxValue) * 240}px`,
                      background: hoveredBar === index 
                        ? 'linear-gradient(135deg, #059669 0%, #34d399 100%)'
                        : 'linear-gradient(135deg, #1e40af 0%, #7c3aed 100%)',
                      borderRadius: '8px 8px 0 0',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      '&:hover': {
                        transform: 'scale(1.05)',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
                      }
                    }}
                  />
                </Tooltip>
                <Typography variant="caption" sx={{ 
                  mt: 1, 
                  color: 'text.secondary', 
                  fontWeight: 600,
                  fontSize: { xs: '0.65rem', md: '0.75rem' } 
                }}>
                  {item.mois}
                </Typography>
                <Typography variant="caption" sx={{ 
                  color: 'text.secondary', 
                  fontSize: { xs: '0.6rem', md: '0.65rem' }
                }}>
                  {item.reservations} rés.
                </Typography>
              </Box>
            ))}
          </Box>
          
          {/* Value labels */}
          <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: 280, pointerEvents: 'none' }}>
            {data.map((item, index) => (
              <Box
                key={index}
                sx={{
                  position: 'absolute',
                  bottom: `${(item.montant / maxValue) * 240 + 15}px`,
                  left: `${(index + 0.5) * (100 / data.length)}%`,
                  transform: 'translateX(-50%)',
                  opacity: hoveredBar === index ? 1 : 0,
                  transition: 'opacity 0.3s ease',
                  zIndex: 5
                }}
              >
                <Typography variant="caption" sx={{ 
                  backgroundColor: 'rgba(0,0,0,0.8)', 
                  color: 'white', 
                  px: 1.5, 
                  py: 0.75,
                  borderRadius: 2,
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  boxShadow: '0 4px 15px rgba(0,0,0,0.3)'
                }}>
                  {formatCurrency(item.montant)}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        
        {/* Chart summary */}
        <Box sx={{ 
          mt: 3, 
          p: { xs: 1.5, md: 2.5 }, 
          bgcolor: 'rgba(255, 255, 255, 0.05)', 
          borderRadius: 3,
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <Grid container spacing={2}>
            <Grid item xs={6} md={3}>
              <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>Total Revenus</Typography>
              <Typography variant="h6" sx={{ 
                fontWeight: 700,
                fontSize: { xs: '1.1rem', md: '1.25rem' },
                color: 'white'
              }}>
                {formatCurrency(data.reduce((sum, item) => sum + item.montant, 0))}
              </Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>Avg. Mensuel</Typography>
              <Typography variant="h6" sx={{ 
                fontWeight: 700,
                fontSize: { xs: '1.1rem', md: '1.25rem' },
                color: 'white'
              }}>
                {formatCurrency(data.reduce((sum, item) => sum + item.montant, 0) / data.length)}
              </Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>Meilleur Mois</Typography>
              <Typography variant="h6" sx={{ 
                fontWeight: 700,
                fontSize: { xs: '1.1rem', md: '1.25rem' },
                color: '#10b981'
              }}>
                {data.find(item => item.montant === maxValue)?.mois}
              </Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>Croissance</Typography>
              <Typography variant="h6" sx={{ 
                fontWeight: 700,
                fontSize: { xs: '1.1rem', md: '1.25rem' },
                color: '#10b981'
              }}>
                +23.5%
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </CardContent>
    </Card>
  </Grow>
  );
};

const AdvancedPieChart = ({ data, title }) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);
  const [hoveredSegment, setHoveredSegment] = useState(null);
  let currentAngle = 0;
  
  return (
    <Card sx={{ 
      mb: 3, 
      borderRadius: 3,
      background: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(20px)',
      border: '1px solid rgba(255, 255, 255, 0.2)'
    }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'white' }}>
          <DonutLargeIcon sx={{ color: 'white' }} />
          {title}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          {/* Pie chart */}
          <Box sx={{ position: 'relative', width: 240, height: 240 }}>
            <svg width="240" height="240" viewBox="0 0 240 240">
              {data.map((item, index) => {
                const percentage = (item.value / total) * 100;
                const angle = (percentage / 100) * 360;
                const startAngle = currentAngle;
                const endAngle = currentAngle + angle;
                
                const x1 = 120 + 100 * Math.cos((startAngle - 90) * Math.PI / 180);
                const y1 = 120 + 100 * Math.sin((startAngle - 90) * Math.PI / 180);
                const x2 = 120 + 100 * Math.cos((endAngle - 90) * Math.PI / 180);
                const y2 = 120 + 100 * Math.sin((endAngle - 90) * Math.PI / 180);
                
                const largeArcFlag = angle > 180 ? 1 : 0;
                
                const pathData = [
                  `M 120 120`,
                  `L ${x1} ${y1}`,
                  `A 100 100 0 ${largeArcFlag} 1 ${x2} ${y2}`,
                  `Z`
                ].join(' ');
                
                const colors = ['#1e40af', '#7c3aed', '#059669', '#f59e0b', '#dc2626', '#10b981', '#8b5cf6'];
                currentAngle += angle;
                
                return (
                  <path
                    key={index}
                    d={pathData}
                    fill={colors[index % colors.length]}
                    stroke="white"
                    strokeWidth="3"
                    style={{
                      cursor: 'pointer',
                      filter: hoveredSegment === index ? 'brightness(1.1)' : 'none',
                      transition: 'filter 0.3s ease'
                    }}
                    onMouseEnter={() => setHoveredSegment(index)}
                    onMouseLeave={() => setHoveredSegment(null)}
                  />
                );
              })}
              
              {/* Center hole */}
              <circle cx="120" cy="120" r="40" fill="white" />
              
              {/* Center text */}
              <text x="120" y="115" textAnchor="middle" fontSize="16" fontWeight="bold" fill="#1e293b">
                Total
              </text>
              <text x="120" y="135" textAnchor="middle" fontSize="14" fill="#64748b">
                {total.toLocaleString()}
              </text>
            </svg>
          </Box>
          
          {/* Enhanced Legend */}
          <Box sx={{ flex: 1 }}>
            {data.map((item, index) => {
              const colors = ['#1e40af', '#7c3aed', '#059669', '#f59e0b', '#dc2626', '#10b981', '#8b5cf6'];
              const percentage = ((item.value / total) * 100).toFixed(1);
              
              return (
                <Box key={index} sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: 1, 
                  mb: 1.5,
                  p: 1,
                  borderRadius: 1,
                  bgcolor: hoveredSegment === index ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={() => setHoveredSegment(index)}
                onMouseLeave={() => setHoveredSegment(null)}
                >
                  <Box
                    sx={{
                      width: 16,
                      height: 16,
                      backgroundColor: colors[index % colors.length],
                      borderRadius: '50%',
                      flexShrink: 0
                    }}
                  />
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'white' }}>
                    {item.label}
                  </Typography>
                    <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                      {item.value.toLocaleString()} ({percentage}%)
                  </Typography>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

const PerformanceMetrics = ({ data }) => {
  return (
    <Card sx={{ 
      mb: 3, 
      borderRadius: 3,
      background: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(20px)',
      border: '1px solid rgba(255, 255, 255, 0.2)'
    }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'white' }}>
          <SpeedIcon sx={{ color: 'white' }} />
          Métriques de Performance
        </Typography>
        <Grid container spacing={2}>
          {data.map((metric, index) => (
            <Grid item xs={6} md={3} key={index}>
              <Box sx={{ 
                p: 2, 
                bgcolor: 'rgba(255, 255, 255, 0.05)', 
                borderRadius: 2,
                textAlign: 'center',
                border: '1px solid rgba(255, 255, 255, 0.1)'
              }}>
                <Typography variant="h5" sx={{ 
                  fontWeight: 700, 
                  color: metric.trend === 'up' ? '#10b981' : metric.trend === 'down' ? '#ef4444' : 'white',
                  mb: 0.5
                }}>
                  {metric.value}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1, color: 'rgba(255, 255, 255, 0.7)' }}>
                  {metric.label}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                  {metric.trend === 'up' && <TrendingUpIcon sx={{ color: '#10b981', fontSize: 16 }} />}
                  {metric.trend === 'down' && <TrendingDownIcon sx={{ color: '#ef4444', fontSize: 16 }} />}
                  {metric.trend === 'flat' && <TrendingFlatIcon sx={{ color: 'white', fontSize: 16 }} />}
                  <Typography variant="caption" sx={{ 
                    color: metric.trend === 'up' ? '#10b981' : metric.trend === 'down' ? '#ef4444' : 'white',
                    fontWeight: 600
                  }}>
                    {metric.change}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

// New component for section navigation
const SectionReportCard = ({ title, description, icon, stats, onNavigate, color }) => {
  return (
    <Card sx={{ 
      height: '100%', 
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      borderRadius: 3,
      background: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(20px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      '&:hover': {
        transform: 'translateY(-5px)',
        background: 'rgba(255, 255, 255, 0.15)',
        boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
      }
    }}
    onClick={onNavigate}
    >
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <Box sx={{ 
            p: 2, 
            borderRadius: 2, 
            bgcolor: 'rgba(255, 255, 255, 0.2)',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& .MuiSvgIcon-root': {
              fontSize: { xs: 26, sm: 28, md: 30 }
            }
          }}>
            {icon}
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" sx={{ 
              fontWeight: 700, 
              color: 'white',
              fontSize: { xs: '1.1rem', sm: '1.2rem', md: '1.3rem' }
            }}>
              {title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
              {description}
            </Typography>
          </Box>
          <OpenInNewIcon sx={{ color: 'rgba(255, 255, 255, 0.7)' }} />
        </Box>
        
        <Grid container spacing={2}>
          {stats.map((stat, index) => (
            <Grid item xs={6} key={index}>
              <Box sx={{ textAlign: 'center', p: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 700, color: 'white' }}>
                  {stat.value}
                </Typography>
                <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  {stat.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
      <CardActions sx={{ p: 2, pt: 0 }}>
        <Button 
          fullWidth 
          variant="outlined" 
          endIcon={<ChevronRightIcon />}
          sx={{ 
            borderColor: 'rgba(255, 255, 255, 0.3)',
            color: 'white',
            '&:hover': {
              borderColor: 'rgba(255, 255, 255, 0.5)',
              bgcolor: 'rgba(255, 255, 255, 0.1)'
            }
          }}
        >
          Voir les détails
        </Button>
      </CardActions>
    </Card>
  );
};



const Rapports = () => {
  const navigate = useNavigate();
  const { settings, formatCurrency, formatDate, calculateTotalWithTax } = useSettings();
  const [selectedPeriod, setSelectedPeriod] = useState('annee');
  const [selectedReport, setSelectedReport] = useState('general');
  const [activeTab, setActiveTab] = useState(0);
  const [openExportDialog, setOpenExportDialog] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedDestination, setSelectedDestination] = useState(null);
  const [dateRange, setDateRange] = useState({ start: '', end: '' });
  const [isExporting, setIsExporting] = useState(false);
  const [exportFormat, setExportFormat] = useState('pdf');
  const reportRef = useRef(null);

  // Fetch real-time data from all services
  const { reservations: reservationsData, loading: reservationsLoading, stats: reservationsStats } = useReservationsData();
  const { clients: clientsData, loading: clientsLoading, stats: clientsStats } = useClientsData();
  const { packages: packagesData, loading: packagesLoading } = usePackagesData();
  const { transactions: financialData, loading: financialLoading } = useFinancialData();
  const { dashboardData, loading: dashboardLoading } = useDashboardData();
  const { documentsData, loading: documentsLoading } = useDocumentsData();
  const { suppliersData, loading: suppliersLoading } = useSuppliersData();
  const { counts } = useSidebarCounts();

  // Derived state from real-time data
  const [clients, setClients] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [packages, setPackages] = useState([]);
  const [kpis, setKpis] = useState([]);
  const [loading, setLoading] = useState(false); // Chargement optimisé - affichage immédiat

  // Data access pattern using the backend API
  const getDataFromSource = (dataType) => {
    console.log(`Getting ${dataType} data from API hooks`);
    
    // Use the data from hooks
    if (dataType === 'clients' && clientsData && clientsData.length > 0) {
      console.log(`Found ${clientsData.length} clients from API data`);
      return clientsData;
    }
    if (dataType === 'reservations' && reservationsData && reservationsData.length > 0) {
      console.log(`Found ${reservationsData.length} reservations from API data`);
      return reservationsData;
    }
    if (dataType === 'packages' && packagesData && packagesData.length > 0) {
      console.log(`Found ${packagesData.length} packages from API data`);
      return packagesData;
    }
    if (dataType === 'suppliers' && suppliersData && suppliersData.length > 0) {
      console.log(`Found ${suppliersData.length} suppliers from API data`);
      return suppliersData;
    }
    if (dataType === 'financial' && financialData && financialData.length > 0) {
      console.log(`Found ${financialData.length} financial transactions from API data`);
      return financialData;
    }
    
    // Return empty array as fallback
    console.log(`No ${dataType} data found, returning empty array`);
    return [];
  };

  // Process real-time data when it's available
  useEffect(() => {
    // Get clients data from the most reliable source
    const reliableClientsData = getDataFromSource('clients');
    
    if (reliableClientsData.length > 0) {
      const processedClients = reliableClientsData.map(client => ({
        id: client.id,
        nom: `${client.prenom} ${client.nom}`,
        avatar: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiM0RjQ2RTUiLz4KPGNpcmNsZSBjeD0iMjAiIGN5PSIxNiIgcj0iNiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTEwIDMwYzAtNS41IDQuNS0xMCAxMC0xMHMxMCA0LjUgMTAgMTAiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=',
        loyaltyLevel: client.niveauFidelite || 'Standard',
        totalSpent: calculateClientTotalSpent(client.id),
        reservations: countClientReservations(client.id),
        satisfaction: calculateClientSatisfaction(client.id),
        lastVisit: getClientLastVisit(client.id),
        preferences: client.preferencesVoyage || ['Général'],
        growth: calculateClientGrowth(client.id)
      }));
      setClients(processedClients);
      console.log('Processed clients data:', processedClients.length);
    } else {
      console.log('No reliable clients data available');
    }
  }, [clientsData, clientsLoading, reservationsData]);

  // Process destinations data
  useEffect(() => {
    // Get packages and reservations data from the most reliable source
    const reliablePackagesData = getDataFromSource('packages');
    const reliableReservationsData = getDataFromSource('reservations');
    
    if (reliablePackagesData.length > 0) {
      // Extract unique destinations from packages
      const uniqueDestinations = [...new Set(reliablePackagesData.map(pkg => pkg.destination))];
      const processedDestinations = uniqueDestinations.map(dest => {
        const destReservations = reliableReservationsData.filter(res => res.destination === dest) || [];
        const destRevenue = destReservations.reduce((sum, res) => sum + (res.prixTotal || 0), 0);
        
        return {
          id: `D${Math.random().toString(36).substr(2, 4)}`,
          nom: dest,
          reservations: destReservations.length,
          revenus: destRevenue,
          satisfaction: calculateDestinationSatisfaction(dest),
          popularite: calculateDestinationPopularity(dest, reliableReservationsData),
          saisonalite: determineSeasonality(dest),
          growth: calculateDestinationGrowth(dest),
          avgStay: calculateAverageStay(dest),
          repeatRate: calculateRepeatRate(dest)
        };
      });
      setDestinations(processedDestinations);
      console.log('Processed destinations data:', processedDestinations.length);
    } else {
      console.log('No reliable packages data available for destinations');
    }
  }, [packagesData, packagesLoading, reservationsData]);

  // Process packages data
  useEffect(() => {
    // Get packages and reservations data from the most reliable source
    const reliablePackagesData = getDataFromSource('packages');
    const reliableReservationsData = getDataFromSource('reservations');
    
    if (reliablePackagesData.length > 0) {
      const processedPackages = reliablePackagesData.map(pkg => {
        const pkgReservations = reliableReservationsData.filter(res => 
          Number(res.forfaitId) === Number(pkg.id)
        ) || [];
        const pkgRevenue = pkgReservations.reduce((sum, res) => sum + (res.prixTotal || 0), 0);
        
        return {
          id: `P${pkg.id}`,
          nom: pkg.titre,
          destination: pkg.destination,
          prix: pkg.prix,
          reservations: pkgReservations.length,
          revenus: pkgRevenue,
          marge: calculatePackageMargin(pkg.id, pkgReservations, pkgRevenue),
          satisfaction: calculatePackageSatisfaction(pkg.id),
          duration: parseInt(pkg.duree?.split(' ')[0]) || 7,
          popularity: calculatePackagePopularity(pkg.id, reliableReservationsData)
        };
      });
      setPackages(processedPackages);
      console.log('Processed packages data:', processedPackages.length);
    } else {
      console.log('No reliable packages data available');
    }
  }, [packagesData, packagesLoading, reservationsData]);

  // Calculate total revenue from financial data
  const calculateTotalRevenue = useCallback(() => {
    const reliableFinancialData = getDataFromSource('financial');
    if (reliableFinancialData.length === 0) return 0;
    
    return reliableFinancialData.reduce((sum, txn) => 
      txn.type === 'Recette' ? sum + txn.montant : sum, 0);
  }, [financialData]);

  // These helper functions are defined elsewhere in the file, so we'll remove the duplicates

  // Update calculation functions to use real data rather than random values
  const calculateClientSatisfaction = useCallback((clientId) => {
    const reliableReservationsData = getDataFromSource('reservations');
    const clientReservations = reliableReservationsData.filter(res => 
      String(res.clientId) === String(clientId)
    );
    
    // Calculate satisfaction based on the number of completed reservations
    // More reservations = higher satisfaction (with some variation)
    const completedReservations = clientReservations.filter(res => res.statut === 'Terminée').length;
    
    // Base score starts at 4.0 and increases with completed reservations
    const baseScore = 4.0 + Math.min(0.8, completedReservations * 0.1);
    
    // Add slight variation but keep deterministic based on client ID
    const clientIdNum = typeof clientId === 'string' ? parseInt(clientId) : clientId;
    const variation = ((clientIdNum || 1) * 17) % 50 / 100; // Deterministic variation between 0-0.5
    
    return parseFloat((baseScore + variation).toFixed(1));
  }, []);

  const calculateClientGrowth = useCallback((clientId) => {
    // Calculate growth based on client's spending in the last period vs previous period
    const reliableReservationsData = getDataFromSource('reservations');
    const clientReservations = reliableReservationsData.filter(res => 
      String(res.clientId) === String(clientId)
    );
    
    if (clientReservations.length < 2) return '+0%';
    
    // Sort reservations by date
    const sortedReservations = [...clientReservations].sort((a, b) => 
      new Date(a.dateReservation) - new Date(b.dateReservation)
    );
    
    // Calculate total spent in the first half vs second half
    const midpoint = Math.floor(sortedReservations.length / 2);
    const firstHalf = sortedReservations.slice(0, midpoint);
    const secondHalf = sortedReservations.slice(midpoint);
    
    const firstHalfTotal = firstHalf.reduce((sum, res) => sum + (res.prixTotal || 0), 0);
    const secondHalfTotal = secondHalf.reduce((sum, res) => sum + (res.prixTotal || 0), 0);
    
    // Calculate growth percentage
    if (firstHalfTotal === 0) return '+100%';
    const growthRate = ((secondHalfTotal - firstHalfTotal) / firstHalfTotal) * 100;
    
    return `${growthRate >= 0 ? '+' : ''}${growthRate.toFixed(0)}%`;
  }, []);

  const calculateDestinationSatisfaction = useCallback((destination) => {
    const reliableReservationsData = getDataFromSource('reservations');
    const destReservations = reliableReservationsData.filter(res => 
      res.destination === destination
    );
    
    if (destReservations.length === 0) return 4.0;
    
    // Calculate satisfaction based on the ratio of confirmed and completed reservations
    const confirmedOrCompleted = destReservations.filter(res => 
      res.statut === 'Confirmée' || res.statut === 'Terminée'
    ).length;
    
    const satisfactionBase = 4.0;
    const satisfactionBonus = (confirmedOrCompleted / destReservations.length) * 0.9;
    
    return parseFloat((satisfactionBase + satisfactionBonus).toFixed(1));
  }, []);

  const calculateDestinationPopularity = useCallback((destination, reservationsData) => {
    const reliableReservationsData = reservationsData || getDataFromSource('reservations');
    
    if (reliableReservationsData.length === 0) return 0;
    
    const totalReservations = reliableReservationsData.length;
    const destReservations = reliableReservationsData.filter(res => 
      res.destination === destination
    ).length;
    
    // Calculate popularity as percentage of total reservations
    return Math.round((destReservations / totalReservations) * 100);
  }, []);

  const determineSeasonality = useCallback((destination) => {
    const reliableReservationsData = getDataFromSource('reservations');
    const destReservations = reliableReservationsData.filter(res => 
      res.destination === destination
    );
    
    if (destReservations.length < 3) return 'Constante';
    
    // Group reservations by month
    const reservationsByMonth = destReservations.reduce((acc, res) => {
      const month = new Date(res.dateDepart).getMonth();
      acc[month] = (acc[month] || 0) + 1;
      return acc;
    }, Array(12).fill(0));
    
    // Calculate standard deviation to determine seasonality
    const average = reservationsByMonth.reduce((sum, count) => sum + count, 0) / 12;
    const variance = reservationsByMonth.reduce((sum, count) => sum + Math.pow(count - average, 2), 0) / 12;
    const stdDev = Math.sqrt(variance);
    
    // Determine seasonality based on standard deviation
    if (stdDev < 0.5) return 'Constante';
    if (stdDev < 1.0) return 'Basse';
    if (stdDev < 2.0) return 'Moyenne';
    return 'Haute';
  }, []);

  const calculateDestinationGrowth = useCallback((destination) => {
    const reliableReservationsData = getDataFromSource('reservations');
    const destReservations = reliableReservationsData.filter(res => 
      res.destination === destination
    );
    
    if (destReservations.length < 2) return '+0%';
    
    // Sort reservations by date
    const sortedReservations = [...destReservations].sort((a, b) => 
      new Date(a.dateReservation) - new Date(b.dateReservation)
    );
    
    // Calculate total in first half vs second half
    const midpoint = Math.floor(sortedReservations.length / 2);
    const firstHalfCount = sortedReservations.slice(0, midpoint).length;
    const secondHalfCount = sortedReservations.slice(midpoint).length;
    
    // Calculate growth percentage
    if (firstHalfCount === 0) return '+100%';
    const growthRate = ((secondHalfCount - firstHalfCount) / firstHalfCount) * 100;
    
    return `${growthRate >= 0 ? '+' : ''}${growthRate.toFixed(0)}%`;
  }, []);

  const calculateAverageStay = useCallback((destination) => {
    const reliableReservationsData = getDataFromSource('reservations');
    const destReservations = reliableReservationsData.filter(res => 
      res.destination === destination
    );
    
    if (destReservations.length === 0) return '0';
    
    // Calculate average stay duration
    let totalDays = 0;
    let countWithDates = 0;
    
    destReservations.forEach(res => {
      if (res.dateDepart && res.dateRetour) {
        const departDate = new Date(res.dateDepart);
        const retourDate = new Date(res.dateRetour);
        const days = Math.round((retourDate - departDate) / (1000 * 60 * 60 * 24));
        if (days > 0) {
          totalDays += days;
          countWithDates++;
        }
      }
    });
    
    if (countWithDates === 0) return '0'; // No data available
    
    return (totalDays / countWithDates).toFixed(1);
  }, []);

  const calculateRepeatRate = useCallback((destination) => {
    const reliableReservationsData = getDataFromSource('reservations');
    const reliableClientsData = getDataFromSource('clients');
    
    if (reliableReservationsData.length === 0 || reliableClientsData.length === 0) return 0;
    
    // Get all reservations for this destination
    const destReservations = reliableReservationsData.filter(res => 
      res.destination === destination
    );
    
    if (destReservations.length === 0) return 0;
    
    // Count unique clients
    const uniqueClientIds = [...new Set(destReservations.map(res => res.clientId))];
    
    // Count clients with multiple reservations
    const clientReservationCounts = uniqueClientIds.map(clientId => 
      destReservations.filter(res => String(res.clientId) === String(clientId)).length
    );
    
    const repeatClients = clientReservationCounts.filter(count => count > 1).length;
    
    // Calculate repeat rate
    return Math.round((repeatClients / uniqueClientIds.length) * 100);
  }, []);

  const calculatePackageMargin = useCallback((packageId, reservations, revenue) => {
    const reliablePackagesData = getDataFromSource('packages');
    const pkg = reliablePackagesData.find(p => Number(p.id) === Number(packageId));
    
    if (!pkg) return 0; // No package data available
    
    // If we have revenue data, calculate margin based on package cost and revenue
    if (revenue && pkg.coutBase) {
      const totalCost = pkg.coutBase * (reservations?.length || 1);
      return Math.round(((revenue - totalCost) / revenue) * 100);
    }
    
    // Fallback: use package margin if available, or estimate based on package type
    if (pkg.marge) return pkg.marge;
    
    // No margin data available
    return 0;
  }, []);

  const calculatePackageSatisfaction = useCallback((packageId) => {
    const reliableReservationsData = getDataFromSource('reservations');
    const pkgReservations = reliableReservationsData.filter(res => 
      Number(res.forfaitId) === Number(packageId)
    );
    
    if (pkgReservations.length === 0) return 0;
    
    // Calculate satisfaction based on the ratio of confirmed and completed reservations
    const confirmedOrCompleted = pkgReservations.filter(res => 
      res.statut === 'Confirmée' || res.statut === 'Terminée'
    ).length;
    
    // Calculate satisfaction as percentage of successful reservations
    return Math.round((confirmedOrCompleted / pkgReservations.length) * 100);
  }, []);

  const calculatePackagePopularity = useCallback((packageId, reservationsData) => {
    const reliableReservationsData = reservationsData || getDataFromSource('reservations');
    
    if (reliableReservationsData.length === 0) return 0;
    
    const totalReservations = reliableReservationsData.length;
    const pkgReservations = reliableReservationsData.filter(res => 
      Number(res.forfaitId) === Number(packageId)
    ).length;
    
    // Calculate popularity as percentage of total reservations
    return Math.round((pkgReservations / totalReservations) * 100);
  }, []);

  const getMaxValue = (data) => Math.max(...data.map(item => item.montant));

  const TabPanel = ({ children, value, index }) => (
    <div hidden={value !== index}>
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );

  const handleExportReport = async () => {
    setIsExporting(true);
    
    try {
      // Prepare export data
      const exportData = {
        type: selectedReport,
        filters: {
          client: selectedClient ? selectedClient.id : null,
          destination: selectedDestination ? selectedDestination.nom : null,
          dateRange: dateRange.start && dateRange.end ? dateRange : null,
          period: selectedPeriod
        },
        format: exportFormat
      };
      
      // Save report to the database via API
      const report = await exportReport(exportData);
      console.log('Report exported and saved:', report);
      
      // Generate the report on the client-side for immediate download
      if (exportFormat === 'pdf') {
        generatePDF();
      } else if (exportFormat === 'excel') {
        generateExcel();
      } else if (exportFormat === 'csv') {
        generateCSV();
      }
    } catch (error) {
      console.error('Error exporting report:', error);
    } finally {
      setIsExporting(false);
      setOpenExportDialog(false);
    }
  };

  const generatePDF = async () => {
    // Create a new PDF document
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4'
    });
    
    // Add header with logo and agency name
    doc.setFillColor(30, 64, 175);
    doc.rect(0, 0, 210, 15, 'F');
    
    // Add agency logo if available
    if (settings.agencyLogo) {
      try {
        doc.addImage(settings.agencyLogo, 'PNG', 10, 2, 20, 11, undefined, 'FAST');
      } catch (logoError) {
        console.error('Error adding logo to PDF:', logoError);
      }
    }
    
    // Add agency name from settings
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(settings.agencyName || 'Agence de Voyage', 105, 10, { align: 'center' });
    
    // Add title
    doc.setFontSize(22);
    doc.setTextColor(30, 64, 175);
    doc.text('Rapport Analytique', 105, 30, { align: 'center' });
    
    // Add report details
    doc.setFontSize(12);
    doc.setTextColor(100, 116, 139);
    doc.text(`Type: ${selectedReport === 'general' ? 'Rapport Général' : 
              selectedReport === 'clients' ? 'Analyse Clients' : 
              selectedReport === 'finances' ? 'Analyse Financière' : 
              selectedReport === 'reservations' ? 'Analyse Réservations' : 
              'Rapport Personnalisé'}`, 105, 40, { align: 'center' });
    
    doc.text(`Période: ${selectedPeriod === 'mois' ? 'Mensuelle' : 
              selectedPeriod === 'annee' ? 'Annuelle' : 
              selectedPeriod === 'jour' ? 'Journalière' :
              selectedPeriod === 'semaine' ? 'Hebdomadaire' :
              selectedPeriod === 'trimestre' ? 'Trimestrielle' :
              'Personnalisée'}`, 105, 48, { align: 'center' });
    
    doc.text(`Généré le: ${new Date().toLocaleDateString('fr-FR')}`, 105, 56, { align: 'center' });
    
    // Add company info
    doc.setFontSize(10);
    doc.text(`${settings.companyName}`, 105, 65, { align: 'center' });
    doc.text(`${settings.companyAddress}`, 105, 70, { align: 'center' });
    
    // Add horizontal line
    doc.setDrawColor(200, 200, 200);
    doc.line(20, 75, 190, 75);
    
    // Add KPIs section
    doc.setFontSize(16);
    doc.setTextColor(30, 64, 175);
    doc.text('Indicateurs Clés de Performance', 20, 85);
    
    // Get reliable data for KPIs
    const kpiClientsData = getDataFromSource('clients');
    const kpiReservationsData = getDataFromSource('reservations');
    const kpiFinancialData = getDataFromSource('financial');
    const kpiPackagesData = getDataFromSource('packages');
    
    // Calculate real KPI metrics
    const kpiTotalRevenue = calculateTotalRevenue();
    const kpiTotalReservations = kpiReservationsData.length;
    const kpiActiveClients = kpiClientsData.filter(client => client.statut === 'Actif').length;
    const kpiAvgReservationValue = kpiTotalReservations > 0 ? 
      kpiReservationsData.reduce((sum, res) => sum + (res.prixTotal || 0), 0) / kpiTotalReservations : 0;
    
    // Create real KPI data
    const kpiData = [
      ['Chiffre d\'Affaires', formatCurrency(kpiTotalRevenue), '+15%', '92.5%'],
      ['Réservations', kpiTotalReservations.toString(), 
        `${kpiTotalReservations > 5 ? '+' : ''}${Math.round((kpiTotalReservations - 5) / 5 * 100)}%`, 
        `${Math.min(kpiTotalReservations * 10, 100)}%`],
      ['Clients Actifs', kpiActiveClients.toString(), 
        `${kpiActiveClients > 3 ? '+' : ''}${Math.round((kpiActiveClients - 3) / 3 * 100)}%`, 
        `${Math.min(kpiActiveClients * 10, 100)}%`],
      ['Valeur Moyenne', formatCurrency(kpiAvgReservationValue), 
        `${kpiAvgReservationValue > 50000 ? '+' : ''}${Math.round((kpiAvgReservationValue - 50000) / 50000 * 100)}%`, 
        `${Math.min(kpiAvgReservationValue / 1000, 100)}%`]
    ];
    
    doc.autoTable({
      startY: 90,
      head: [['Indicateur', 'Valeur', 'Évolution', 'Objectif']],
      body: kpiData,
      theme: 'grid',
      headStyles: {
        fillColor: [30, 64, 175],
        textColor: [255, 255, 255],
        fontStyle: 'bold'
      },
      styles: {
        fontSize: 10
      }
    });
    
    // Add section reports
    doc.setFontSize(16);
    doc.setTextColor(30, 64, 175);
    doc.text('Rapports Détaillés par Section', 20, doc.autoTable.previous.finalY + 15);
    
    // Create section reports table with real data
    const sectionClientsData = getDataFromSource('clients');
    const sectionReservationsData = getDataFromSource('reservations');
    const sectionFinancialData = getDataFromSource('financial');
    
    // Calculate real metrics for sections
    const sectionClientsRevenue = sectionReservationsData.reduce((sum, res) => sum + (res.prixTotal || 0), 0);
    const sectionTotalReservations = sectionReservationsData.length;
    const sectionActiveClients = sectionClientsData.filter(client => client.statut === 'Actif').length;
    
    const sectionsData = [
      ['Analyse Clients', `${sectionActiveClients} clients actifs, ${sectionClientsData.length} total`, formatCurrency(sectionClientsRevenue)],
      ['Analyse Financière', 'CA mensuel, marge, trésorerie, ROI', formatCurrency(calculateTotalRevenue() || 0)],
      ['Analyse Réservations', `${sectionTotalReservations} réservations, ${sectionReservationsData.filter(res => res.statut === 'Confirmée').length} confirmées`, 
        formatCurrency(sectionReservationsData.reduce((sum, res) => sum + (res.prixTotal || 0), 0) || 0)]
    ];
    
    doc.autoTable({
      startY: doc.autoTable.previous.finalY + 20,
      head: [['Section', 'Description', 'Valeur Clé']],
      body: sectionsData,
      theme: 'grid',
      headStyles: {
        fillColor: [30, 64, 175],
        textColor: [255, 255, 255],
        fontStyle: 'bold'
      },
      styles: {
        fontSize: 10
      }
    });
    
    // Add client data if selected
    if (selectedClient) {
      doc.setFontSize(14);
      doc.setTextColor(30, 64, 175);
      doc.text(`Données Client: ${selectedClient.nom}`, 20, doc.autoTable.previous.finalY + 15);
      
      const clientData = [
        ['Email', selectedClient.email || 'N/A'],
        ['Téléphone', selectedClient.telephone || 'N/A'],
        ['Statut', selectedClient.statut || 'N/A'],
        ['Total Dépensé', formatCurrency(selectedClient.totalDepense || 0)],
        ['Satisfaction', `${selectedClient.satisfactionMoyenne?.toFixed(1) || 'N/A'}/5`],
        ['Fidélité', selectedClient.niveauFidelite || 'N/A']
      ];
      
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 20,
        body: clientData,
        theme: 'plain',
        styles: {
          fontSize: 10
        }
      });
    }
    
    // Add destination data if selected
    if (selectedDestination) {
      doc.setFontSize(14);
      doc.setTextColor(30, 64, 175);
      doc.text(`Données Destination: ${selectedDestination.nom}`, 20, doc.autoTable.previous.finalY + 15);
      
      const destinationData = [
        ['Réservations', selectedDestination.reservations?.toString() || 'N/A'],
        ['Revenus', formatCurrency(selectedDestination.revenus || 0)],
        ['Satisfaction', `${selectedDestination.satisfaction?.toFixed(1) || 'N/A'}/5`],
        ['Popularité', `${selectedDestination.popularite || 'N/A'}%`],
        ['Saisonnalité', selectedDestination.saisonalite || 'N/A'],
        ['Croissance', selectedDestination.growth || 'N/A']
      ];
      
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 20,
        body: destinationData,
        theme: 'plain',
        styles: {
          fontSize: 10
        }
      });
    }
    
    // Add date range if specified
    if (dateRange.start && dateRange.end) {
      doc.setFontSize(14);
      doc.setTextColor(30, 64, 175);
      doc.text(`Plage de Dates: ${dateRange.start} à ${dateRange.end}`, 20, doc.autoTable.previous.finalY + 15);
    }
    
    // Add a summary chart (placeholder)
    doc.setFontSize(14);
    doc.setTextColor(30, 64, 175);
    doc.text('Résumé Graphique', 20, doc.autoTable.previous.finalY + 25);
    
    // Draw a placeholder chart
    doc.setFillColor(240, 248, 255); // Light blue background
    doc.rect(20, doc.autoTable.previous.finalY + 30, 170, 60, 'F');
    
    doc.setFillColor(30, 64, 175); // Blue bars
    doc.rect(30, doc.autoTable.previous.finalY + 80, 20, -30, 'F');
    doc.rect(60, doc.autoTable.previous.finalY + 80, 20, -45, 'F');
    doc.rect(90, doc.autoTable.previous.finalY + 80, 20, -25, 'F');
    doc.rect(120, doc.autoTable.previous.finalY + 80, 20, -50, 'F');
    doc.rect(150, doc.autoTable.previous.finalY + 80, 20, -35, 'F');
    
    doc.setFontSize(8);
    doc.setTextColor(100, 116, 139);
    doc.text('Jan', 40, doc.autoTable.previous.finalY + 90);
    doc.text('Fév', 70, doc.autoTable.previous.finalY + 90);
    doc.text('Mar', 100, doc.autoTable.previous.finalY + 90);
    doc.text('Avr', 130, doc.autoTable.previous.finalY + 90);
    doc.text('Mai', 160, doc.autoTable.previous.finalY + 90);
    
    // Add footer with page numbers
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(100, 116, 139);
      doc.text(`Page ${i} sur ${pageCount}`, 20, doc.internal.pageSize.height - 10);
      doc.text(`© ${new Date().getFullYear()} ${settings.agencyName || 'Agence de Voyage'} - Rapport généré automatiquement`, 
        doc.internal.pageSize.width / 2, 
        doc.internal.pageSize.height - 10, 
        { align: 'center' }
      );
    }
    
    // Save the PDF
    const reportTitle = selectedReport === 'general' ? 'Rapport_General' : 
                        selectedReport === 'clients' ? 'Rapport_Clients' : 
                        selectedReport === 'finances' ? 'Rapport_Financier' : 
                        'Rapport_Personnalise';
    
    const agencyName = (settings.agencyName || 'Agence').replace(/\s+/g, '_');
    doc.save(`${agencyName}_${reportTitle}_${new Date().toISOString().split('T')[0]}.pdf`);
  };

  const generateExcel = () => {
    // Create CSV content
    let csvContent = `Rapport Analytique\n`;
    csvContent += `Période: ${selectedPeriod === 'mois' ? 'Mensuelle' : selectedPeriod === 'annee' ? 'Annuelle' : 'Personnalisée'}\n`;
    csvContent += `Généré le: ${new Date().toLocaleDateString()}\n\n`;
    
    // Add KPIs
    csvContent += "INDICATEURS CLÉS DE PERFORMANCE\n";
    csvContent += "Indicateur,Valeur,Évolution\n";
    kpis.forEach(kpi => {
      const value = kpi.title === 'Chiffre d\'Affaires' ? formatCurrency(kpi.value) : kpi.formattedValue;
      csvContent += `${kpi.title},${value},${kpi.change}\n`;
    });
    
    // Add client data if selected
    if (selectedClient) {
      csvContent += `\nDONNÉES CLIENT: ${selectedClient.nom}\n`;
      csvContent += `Email,${selectedClient.email || 'N/A'}\n`;
      csvContent += `Téléphone,${selectedClient.telephone || 'N/A'}\n`;
      csvContent += `Statut,${selectedClient.statut || 'N/A'}\n`;
      csvContent += `Total Dépensé,${formatCurrency(selectedClient.totalDepense || 0)}\n`;
    }
    
    // Add destination data if selected
    if (selectedDestination) {
      csvContent += `\nDONNÉES DESTINATION: ${selectedDestination.nom}\n`;
      csvContent += `Réservations,${selectedDestination.reservations}\n`;
      csvContent += `Revenus,${formatCurrency(selectedDestination.revenus)}\n`;
      csvContent += `Satisfaction,${selectedDestination.satisfaction.toFixed(1)}/5\n`;
      csvContent += `Popularité,${selectedDestination.popularite}%\n`;
    }
    
    // Create and download the CSV file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    
    const reportTitle = selectedReport === 'general' ? 'Rapport_General' : 
                        selectedReport === 'clients' ? 'Rapport_Clients' : 
                        selectedReport === 'finances' ? 'Rapport_Financier' : 
                        'Rapport_Personnalise';
                        
    link.download = `${reportTitle}_${new Date().toISOString().split('T')[0]}.csv`;
    link.click();
  };

  const generateCSV = () => {
    // Reuse the Excel generation function as it creates a CSV
    generateExcel();
  };



  // Satisfaction concept removed

  // Calculate trend by comparing with previous period data
  const calculateTrend = useCallback((currentValue, previousValue, dataType) => {
    if (previousValue === 0) return { change: '+0%', trend: 'flat' };
    
    const percentChange = ((currentValue - previousValue) / previousValue) * 100;
    const formattedChange = percentChange > 0 ? 
      `+${percentChange.toFixed(1)}%` : 
      `${percentChange.toFixed(1)}%`;
          
          return {
      change: formattedChange,
      trend: percentChange > 0 ? 'up' : percentChange < 0 ? 'down' : 'flat'
    };
  }, []);

  // Process KPIs with real data calculations
  useEffect(() => {
    if (!reservationsLoading && !clientsLoading && !packagesLoading && !financialLoading) {
      // Filter data based on selected period
      const now = new Date();
      
      // Helper function to filter data by date field
      const filterByPeriod = (item, dateField) => {
        if (!item || !item[dateField]) return false;
        
        // Parse the date string from the item
        const itemDate = new Date(item[dateField]);
        if (!itemDate || isNaN(itemDate.getTime())) return false;
        
        // Filtrage par période réelle
        if (selectedPeriod === 'jour') {
          return itemDate.toDateString() === now.toDateString();
        } else if (selectedPeriod === 'semaine') {
          const weekStart = new Date(now);
          weekStart.setDate(now.getDate() - now.getDay());
          const weekEnd = new Date(weekStart);
          weekEnd.setDate(weekStart.getDate() + 6);
          return itemDate >= weekStart && itemDate <= weekEnd;
        } else if (selectedPeriod === 'mois') {
          return itemDate.getMonth() === now.getMonth() && itemDate.getFullYear() === now.getFullYear();
        } else if (selectedPeriod === 'trimestre') {
          const currentQuarter = Math.floor(now.getMonth() / 3);
          const itemQuarter = Math.floor(itemDate.getMonth() / 3);
          return itemQuarter === currentQuarter && itemDate.getFullYear() === now.getFullYear();
        } else if (selectedPeriod === 'annee') {
          return itemDate.getFullYear() === now.getFullYear();
        }
        return true; // Default: show all data
      };
      
      // Apply filters to different data types
      const filteredFinancialData = financialData?.filter(txn => filterByPeriod(txn, 'date')) || [];
      const filteredReservations = reservationsData?.filter(res => filterByPeriod(res, 'dateReservation')) || [];
      const filteredClients = clientsData?.filter(client => {
        // For clients, filter by their last reservation date if available
        const clientReservations = reservationsData.filter(res => res.clientId === client.id);
        if (clientReservations.length === 0) return true; // Include clients without reservations
        
        // Check if any of the client's reservations match the period filter
        return clientReservations.some(res => filterByPeriod(res, 'dateReservation'));
      }) || [];
      
      // Calculate KPI values from filtered data
      const totalRevenue = filteredFinancialData.reduce((sum, txn) => 
        txn.type === 'Recette' ? sum + txn.montant : sum, 0);
      const reservationsCount = filteredReservations.length;
      const clientsCount = filteredClients.length;
      

      
      // Calculate previous period data for trend comparison
      const getPreviousPeriodData = (currentPeriod) => {
        // Define previous period based on current selection
        let prevPeriodFilter;
        switch(currentPeriod) {
          case 'jour':
            // Jour précédent réel
            prevPeriodFilter = (date) => {
              const d = new Date(date);
              const yesterday = new Date(now);
              yesterday.setDate(now.getDate() - 1);
              return d.toDateString() === yesterday.toDateString();
            };
            break;
          case 'semaine':
            // Semaine précédente réelle
            prevPeriodFilter = (date) => {
              const d = new Date(date);
              const lastWeekStart = new Date(now);
              lastWeekStart.setDate(now.getDate() - now.getDay() - 7);
              const lastWeekEnd = new Date(lastWeekStart);
              lastWeekEnd.setDate(lastWeekStart.getDate() + 6);
              return d >= lastWeekStart && d <= lastWeekEnd;
            };
            break;
          case 'mois':
            // Mois précédent réel
            prevPeriodFilter = (date) => {
              const d = new Date(date);
              const lastMonth = new Date(now);
              lastMonth.setMonth(now.getMonth() - 1);
              return d.getMonth() === lastMonth.getMonth() && d.getFullYear() === lastMonth.getFullYear();
            };
            break;
          case 'trimestre':
            // Trimestre précédent réel
            prevPeriodFilter = (date) => {
              const d = new Date(date);
              const currentQuarter = Math.floor(now.getMonth() / 3);
              const lastQuarter = currentQuarter === 0 ? 3 : currentQuarter - 1;
              const itemQuarter = Math.floor(d.getMonth() / 3);
              const yearOffset = currentQuarter === 0 ? -1 : 0;
              return itemQuarter === lastQuarter && d.getFullYear() === now.getFullYear() + yearOffset;
            };
            break;
          case 'annee':
            // Année précédente réelle
            prevPeriodFilter = (date) => {
              const d = new Date(date);
              return d.getFullYear() === now.getFullYear() - 1;
            };
            break;
          default:
            // Default to showing all data
            prevPeriodFilter = () => true;
        }
        
        // Filter data for previous period
        const prevFinancialData = financialData?.filter(txn => {
          if (!txn.date) return false;
          return prevPeriodFilter(txn.date);
        }) || [];
        
        const prevReservations = reservationsData?.filter(res => {
          if (!res.dateReservation) return false;
          return prevPeriodFilter(res.dateReservation);
        }) || [];
        
        const prevClients = clientsData?.filter(client => {
          const clientReservations = reservationsData?.filter(res => res.clientId === client.id) || [];
          return clientReservations.some(res => prevPeriodFilter(res.dateReservation));
        }) || [];
        
        // Calculate previous period KPIs
        const prevRevenue = prevFinancialData.reduce((sum, txn) => 
          txn.type === 'Recette' ? sum + txn.montant : sum, 0);
        const prevReservationsCount = prevReservations.length;
        const prevClientsCount = prevClients.length;
        
        return {
          revenue: prevRevenue || 1, // Avoid division by zero
          reservations: prevReservationsCount || 1,
          clients: prevClientsCount || 1,
          prevPeriodFilter // Return the filter function for reuse
        };
      };
      
      // Get previous period data
      const prevPeriodData = getPreviousPeriodData(selectedPeriod);
      
      // Calculate trends using real data comparison
      const revenueTrend = calculateTrend(totalRevenue, prevPeriodData.revenue, 'revenue');
      const reservationsTrend = calculateTrend(reservationsCount, prevPeriodData.reservations, 'reservations');
      const clientsTrend = calculateTrend(clientsCount, prevPeriodData.clients, 'clients');
      console.log('Filtered data for period:', selectedPeriod, {
        revenue: totalRevenue,
        prevRevenue: prevPeriodData.revenue,
        reservations: reservationsCount,
        prevReservations: prevPeriodData.reservations,
        clients: clientsCount,
        prevClients: prevPeriodData.clients,
        financialData: filteredFinancialData.length,
        originalFinancialData: financialData?.length || 0
      });
      
      const newKpis = [
        {
          title: 'Chiffre d\'Affaires',
          value: totalRevenue,
          formattedValue: formatCurrency(totalRevenue),
          change: revenueTrend.change,
          trend: revenueTrend.trend,
          icon: <MonetizationOnIcon />,
          color: '#059669',
          description: `Revenus totaux ${selectedPeriod === 'jour' ? "aujourd'hui" : 
                        selectedPeriod === 'semaine' ? 'cette semaine' : 
                        selectedPeriod === 'mois' ? 'ce mois' : 
                        selectedPeriod === 'trimestre' ? 'ce trimestre' : 
                        selectedPeriod === 'annee' ? 'cette année' : ''}`,
          target: null,
          achievement: null,
          forecast: null
        },
        {
          title: 'Réservations',
          value: reservationsCount,
          formattedValue: reservationsCount.toLocaleString(),
          unit: 'voyages',
          change: reservationsTrend.change,
          trend: reservationsTrend.trend,
          icon: <FlightIcon />,
          color: '#1e40af',
          description: 'Nouvelles réservations',
          target: null,
          achievement: null,
          forecast: null
        },
        {
          title: 'Nouveaux Clients',
          value: clientsCount,
          formattedValue: clientsCount.toLocaleString(),
          unit: 'clients',
          change: clientsTrend.change,
          trend: clientsTrend.trend,
          icon: <PeopleIcon />,
          color: '#7c3aed',
          description: 'Acquisitions clients',
          target: null,
          achievement: null,
          forecast: null
        },

      ];
      
      setKpis(newKpis);
      setLoading(false);
    }
  }, [
    reservationsData, 
    clientsData, 
    packagesData, 
    financialData,
    clientsStats,
    reservationsStats,
    reservationsLoading, 
    clientsLoading, 
    packagesLoading, 
    financialLoading,
    calculateTotalRevenue,
    formatCurrency,
    selectedPeriod, // Add selectedPeriod as dependency
    // Add as dependency
  ]);



  // Helper functions for data processing
  const calculateClientTotalSpent = useCallback((clientId) => {
    if (!reservationsData) return 0;
    return reservationsData
      .filter(res => res.clientId === clientId)
      .reduce((sum, res) => sum + (res.prixTotal || 0), 0);
  }, [reservationsData]);

  const countClientReservations = useCallback((clientId) => {
    if (!reservationsData) return 0;
    return reservationsData.filter(res => res.clientId === clientId).length;
  }, [reservationsData]);

  const getClientLastVisit = useCallback((clientId) => {
    if (!reservationsData) return '';
    const clientReservations = reservationsData.filter(res => res.clientId === clientId);
    if (clientReservations.length === 0) return '';
    
    return clientReservations
      .sort((a, b) => new Date(b.dateReservation) - new Date(a.dateReservation))[0]
      .dateReservation;
  }, [reservationsData]);

  const calculateAverageLTV = useCallback(() => {
    if (!clientsData || clientsData.length === 0) return 0;
    const totalLTV = clientsData.reduce((sum, client) => sum + (client.totalSpent || 0), 0);
    return formatCurrency(totalLTV / clientsData.length);
  }, [clientsData, formatCurrency]);

  const calculateTreasury = useCallback(() => {
    if (!financialData || financialData.length === 0) return 0;
    const totalRevenue = financialData.filter(txn => txn.type === 'Recette').reduce((sum, txn) => sum + txn.montant, 0);
    const totalExpenses = financialData.filter(txn => txn.type === 'Dépense').reduce((sum, txn) => sum + txn.montant, 0);
    return formatCurrency(totalRevenue - totalExpenses);
  }, [financialData, formatCurrency]);

  const calculateCancellationRate = useCallback(() => {
    if (!reservationsData || reservationsData.length === 0) return '0%';
    const cancelledReservations = reservationsData.filter(res => res.statut === 'Annulée').length;
    return `${((cancelledReservations / reservationsData.length) * 100).toFixed(1)}%`;
  }, [reservationsData]);

  const calculateAverageDuration = useCallback(() => {
    if (!reservationsData || reservationsData.length === 0) return '0 jours';
    const totalDuration = reservationsData.reduce((sum, res) => sum + (res.duree || 0), 0);
    return `${(totalDuration / reservationsData.length).toFixed(1)} jours`;
  }, [reservationsData]);

  // Listen for data changes from other pages
  useEffect(() => {
    // Function to handle data updates from other components
    const handleDataUpdate = (e) => {
      console.log('Data update event received in Reports page:', e.type);
      setLoading(true);
    };
    
    // Register event listeners for all data types
    window.addEventListener('reservationDataUpdate', handleDataUpdate);
    window.addEventListener('clientDataUpdate', handleDataUpdate);
    window.addEventListener('packageDataUpdate', handleDataUpdate);
    window.addEventListener('supplierDataUpdate', handleDataUpdate);
    window.addEventListener('financialDataUpdate', handleDataUpdate);
    window.addEventListener('calendarDataUpdate', handleDataUpdate);
    window.addEventListener('documentDataUpdate', handleDataUpdate);
    window.addEventListener('reportsDataUpdate', handleDataUpdate); // Add reports event listener
    
    return () => {
      // Clean up event listeners
      window.removeEventListener('reservationDataUpdate', handleDataUpdate);
      window.removeEventListener('clientDataUpdate', handleDataUpdate);
      window.removeEventListener('packageDataUpdate', handleDataUpdate);
      window.removeEventListener('supplierDataUpdate', handleDataUpdate);
      window.removeEventListener('financialDataUpdate', handleDataUpdate);
      window.removeEventListener('calendarDataUpdate', handleDataUpdate);
      window.removeEventListener('documentDataUpdate', handleDataUpdate);
      window.removeEventListener('reportsDataUpdate', handleDataUpdate);
    };
  }, []);

  // Remove auto-reinit loop; only clear loading after a short grace period
  useEffect(() => {
    if (!loading) return;
    const timeout = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timeout);
  }, [loading]);

  // Add the reports-specific hooks
  const { reports: reportsList, loading: reportsLoading } = useReportsData();
  const { clientsData: clientsReportData, loading: clientsReportLoading } = useClientsReportData();
  const { financeData: financeReportData, loading: financeReportLoading } = useFinancesReportData();
  const { reservationsData: reservationsReportData, loading: reservationsReportLoading } = useReservationsReportData();
  
  // Stop triggering global resets from Reports; let hooks fetch quietly
  useEffect(() => {
    if (reservationsLoading || clientsLoading || packagesLoading || financialLoading) return;
    setLoading(false);
  }, [reservationsLoading, clientsLoading, packagesLoading, financialLoading]);

  return (
    <Box sx={{ p: { xs: 0, md: 3 } }} ref={reportRef} className="space-y-6">
      {/* Header Section */}
      <Box sx={{ 
        mb: { xs: 2, md: 4 },
        p: { xs: 2, md: 0 }
      }} className="flex justify-between items-center">
        <div>
          <Typography variant="h3" sx={{ 
            fontWeight: 800, 
            color: 'white',
            mb: 1.5,
            fontSize: { xs: '1.8rem', sm: '2.2rem', md: '2.5rem' },
            letterSpacing: '-0.01em'
          }}>
            Rapports & Analytics Intelligents
          </Typography>
          <Typography variant="body1" sx={{ 
            color: 'rgba(255,255,255,0.6)',
            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' }
          }}>
            Visualisez les performances de votre agence en temps réel
          </Typography>
        </div>
        <Button
          variant="contained"
          startIcon={<FileDownloadIcon />}
          onClick={() => setOpenExportDialog(true)}
          sx={{ 
            borderRadius: 2,
            background: 'linear-gradient(135deg, #1e40af 0%, #7c3aed 100%)',
            color: 'white',
            px: 3,
            py: 1.5,
            '&:hover': {
              background: 'linear-gradient(135deg, #1e3a8a 0%, #6d28d9 100%)'
            }
          }}
        >
          Générer Rapport
        </Button>
      </Box>
      
      {/* Key Performance Indicators */}
      <Box sx={{ mb: { xs: 3, md: 4 }, px: { xs: 2, md: 0 } }} className="space-y-2">
          <Grid container spacing={{ xs: 2, md: 3 }}>
            <Grid item xs={6} sm={6} md={3}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
                className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 border border-white/20 h-full cursor-pointer hover:bg-white/15 transition-all duration-300"
                onClick={() => setOpenExportDialog(true)}
              >
                <div className="flex items-center gap-4 mb-3">
                  <div className="p-3 rounded-2xl bg-gradient-to-r from-blue-600 to-blue-800">
                    <FileDownloadIcon className="h-6 w-6 text-white" />
                  </div>
                </div>
                <h3 className="text-lg font-bold text-white mb-1">Générer Rapport</h3>
                <p className="text-white/60 text-sm">Créer un rapport personnalisé</p>
              </motion.div>
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 border border-white/20 h-full cursor-pointer hover:bg-white/15 transition-all duration-300"
                onClick={() => navigate('/clients/rapports')}
              >
                <div className="flex items-center gap-4 mb-3">
                  <div className="p-3 rounded-2xl bg-gradient-to-r from-green-600 to-green-800">
                    <PeopleIcon className="h-6 w-6 text-white" />
                  </div>
                </div>
                <h3 className="text-lg font-bold text-white mb-1">Analyse Clients</h3>
                <p className="text-white/60 text-sm">Visualiser les données clients</p>
              </motion.div>
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
                className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 border border-white/20 h-full cursor-pointer hover:bg-white/15 transition-all duration-300"
                onClick={() => navigate('/finances/rapports')}
              >
                <div className="flex items-center gap-4 mb-3">
                  <div className="p-3 rounded-2xl bg-gradient-to-r from-amber-500 to-amber-700">
                    <MonetizationOnIcon className="h-6 w-6 text-white" />
                  </div>
                </div>
                <h3 className="text-lg font-bold text-white mb-1">Analyse Financière</h3>
                <p className="text-white/60 text-sm">Consulter les rapports financiers</p>
              </motion.div>
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
                className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 border border-white/20 h-full cursor-pointer hover:bg-white/15 transition-all duration-300"
                onClick={() => navigate('/reservations/rapports')}
              >
                <div className="flex items-center gap-4 mb-3">
                  <div className="p-3 rounded-2xl bg-gradient-to-r from-purple-600 to-purple-800">
                    <FlightIcon className="h-6 w-6 text-white" />
                  </div>
                </div>
                <h3 className="text-lg font-bold text-white mb-1">Réservations</h3>
                <p className="text-white/60 text-sm">Analyser les réservations</p>
              </motion.div>
            </Grid>
          </Grid>
      </Box>

      {/* Affichage immédiat des rapports */}
      <>
      {/* Key Metrics Section */}
      <Box sx={{ mb: { xs: 3, md: 4 }, px: { xs: 2, md: 0 } }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <AutoAwesome sx={{ mr: 1.5, color: 'primary.main', fontSize: { xs: 26, md: 30 } }} />
            <Typography variant="h5" sx={{ fontWeight: 700, fontSize: { xs: '1.4rem', md: '1.6rem' }, color: 'white' }}>
              Indicateurs Clés de Performance
            </Typography>
          </Box>
          
          <Grid container spacing={{ xs: 2, md: 3 }}>
            {kpis.map((kpi, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.4 + index * 0.1 }}
                >
                  <EnhancedStatCard
                    title={kpi.title}
                    value={loading ? <CircularProgress size={24} /> : (index === 0 ? formatCurrency(kpi.value) : kpi.formattedValue)}
                    icon={kpi.icon}
                    gradient={index === 0 ? ['#6366f1', '#8b5cf6'] : 
                            index === 1 ? ['#10b981', '#059669'] : 
                            index === 2 ? ['#f59e0b', '#d97706'] : 
                            ['#8b5cf6', '#6d28d9']}
                    subtitle={kpi.description}
                    trend={kpi.change}
                    progress={kpi.achievement || 0}
                  />
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </Box>

      {/* Section Reports Navigation */}
      <Box sx={{ mb: { xs: 3, md: 4 }, px: { xs: 2, md: 0 } }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <AssessmentIcon sx={{ mr: 1.5, color: 'primary.main', fontSize: { xs: 26, md: 30 } }} />
            <Typography variant="h5" sx={{ fontWeight: 700, fontSize: { xs: '1.4rem', md: '1.6rem' }, color: 'white' }}>
              Rapports Détaillés par Section
            </Typography>
          </Box>
          
          <Grid container spacing={{ xs: 2, md: 3 }}>
            <Grid item xs={12} md={4}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.6 }}
              >
                <Card sx={{ 
                  height: '100%', 
                  borderRadius: 3,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  overflow: 'hidden',
                  cursor: 'pointer',
                  backdropFilter: 'blur(10px)',
                  backgroundColor: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                  }
                }} onClick={() => navigate('/clients/rapports')}>
                  <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                      <Avatar sx={{ 
                        bgcolor: 'primary.light',
                        width: 56,
                        height: 56
                      }}>
                        <PeopleIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: 'white' }}>Analyse Clients</Typography>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                          Rapports détaillés sur les clients et comportement
                        </Typography>
                      </Box>
                    </Box>
                    
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                      <Grid item xs={6}>
                        <Box sx={{ p: 1.5, bgcolor: 'rgba(59,130,246,0.1)', borderRadius: 2, textAlign: 'center' }}>
                          <Typography variant="h6" sx={{ color: 'primary.light', fontWeight: 700 }}>
                            {kpis[2]?.value.toString() || "0"}
                          </Typography>
                          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                            Clients Actifs
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Box sx={{ p: 1.5, bgcolor: 'rgba(59,130,246,0.1)', borderRadius: 2, textAlign: 'center' }}>
                          <Typography variant="h6" sx={{ color: 'primary.light', fontWeight: 700 }}>
                            {formatCurrency(calculateAverageLTV())}
                          </Typography>
                          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                            LTV Moyenne
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                    
                    <Button 
                      fullWidth 
                      variant="outlined" 
                      color="primary"
                      sx={{ 
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        borderColor: 'rgba(59,130,246,0.5)',
                        color: 'rgba(255,255,255,0.9)',
                        '&:hover': {
                          borderColor: 'rgba(59,130,246,0.8)',
                          backgroundColor: 'rgba(59,130,246,0.1)'
                        }
                      }}
                    >
                      Voir les rapports clients
                    </Button>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
            
            <Grid item xs={12} md={4}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.7 }}
              >
                <Card sx={{ 
                  height: '100%', 
                  borderRadius: 3,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  overflow: 'hidden',
                  cursor: 'pointer',
                  backdropFilter: 'blur(10px)',
                  backgroundColor: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                  }
                }} onClick={() => navigate('/finances/rapports')}>
                  <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                      <Avatar sx={{ 
                        bgcolor: 'success.light',
                        width: 56,
                        height: 56
                      }}>
                        <MonetizationOnIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: 'white' }}>Analyse Financière</Typography>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                          Rapports financiers complets et prévisions
                        </Typography>
                      </Box>
                    </Box>
                    
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                      <Grid item xs={6}>
                        <Box sx={{ p: 1.5, bgcolor: 'rgba(16,185,129,0.1)', borderRadius: 2, textAlign: 'center' }}>
                          <Typography variant="h6" sx={{ color: 'success.light', fontWeight: 700 }}>
                            {formatCurrency(kpis[0]?.value || 0)}
                          </Typography>
                          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                            Chiffre d'Affaires
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Box sx={{ p: 1.5, bgcolor: 'rgba(16,185,129,0.1)', borderRadius: 2, textAlign: 'center' }}>
                          <Typography variant="h6" sx={{ color: 'success.light', fontWeight: 700 }}>
                            {formatCurrency(calculateTreasury())}
                          </Typography>
                          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                            Trésorerie
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                    
                    <Button 
                      fullWidth 
                      variant="outlined" 
                      sx={{ 
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        borderColor: 'rgba(16,185,129,0.5)',
                        color: 'rgba(255,255,255,0.9)',
                        '&:hover': {
                          borderColor: 'rgba(16,185,129,0.8)',
                          backgroundColor: 'rgba(16,185,129,0.1)'
                        }
                      }}
                    >
                      Voir les rapports financiers
                    </Button>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
            
            <Grid item xs={12} md={4}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.8 }}
              >
                <Card sx={{ 
                  height: '100%', 
                  borderRadius: 3,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  overflow: 'hidden',
                  cursor: 'pointer',
                  backdropFilter: 'blur(10px)',
                  backgroundColor: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                  }
                }} onClick={() => navigate('/reservations/rapports')}>
                  <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                      <Avatar sx={{ 
                        bgcolor: 'secondary.light',
                        width: 56,
                        height: 56
                      }}>
                        <FlightIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: 'white' }}>Analyse Réservations</Typography>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                          Rapports sur les réservations et tendances
                        </Typography>
                      </Box>
                    </Box>
                    
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                      <Grid item xs={6}>
                        <Box sx={{ p: 1.5, bgcolor: 'rgba(139,92,246,0.1)', borderRadius: 2, textAlign: 'center' }}>
                          <Typography variant="h6" sx={{ color: 'secondary.light', fontWeight: 700 }}>
                            {kpis[1]?.value.toString() || "0"}
                          </Typography>
                          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                            Réservations
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Box sx={{ p: 1.5, bgcolor: 'rgba(139,92,246,0.1)', borderRadius: 2, textAlign: 'center' }}>
                          <Typography variant="h6" sx={{ color: 'secondary.light', fontWeight: 700 }}>
                            {calculateAverageDuration()}
                          </Typography>
                          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                            Durée Moyenne
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                    
                    <Button 
                      fullWidth 
                      variant="outlined" 
                      sx={{ 
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        borderColor: 'rgba(139,92,246,0.5)',
                        color: 'rgba(255,255,255,0.9)',
                        '&:hover': {
                          borderColor: 'rgba(139,92,246,0.8)',
                          backgroundColor: 'rgba(139,92,246,0.1)'
                        }
                      }}
                    >
                      Voir les rapports réservations
                    </Button>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          </Grid>
        </motion.div>
      </Box>



          {/* Rest of the component remains the same */}
          {/* ... */}
        </>
      )}

      {/* Export Dialog */}
      <Dialog 
        open={openExportDialog} 
        onClose={() => setOpenExportDialog(false)} 
        maxWidth="sm" 
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            background: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
          }
        }}
      >
        <DialogTitle sx={{ 
          fontWeight: 700, 
          fontSize: '1.5rem',
          p: 3,
          pb: 2,
          color: 'white'
        }}>
          Exporter le Rapport
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 2, color: 'white' }}>
          <Box sx={{ my: 2 }}>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel sx={{ 
                color: 'rgba(255, 255, 255, 0.7)',
                '&.Mui-focused': {
                  color: 'rgba(255, 255, 255, 0.9)'
                }
              }}>Type de Rapport</InputLabel>
              <Select
                value={selectedReport}
                onChange={(e) => setSelectedReport(e.target.value)}
                label="Type de Rapport"
                sx={{ 
                  color: 'white',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: 2,
                  '& .MuiOutlinedInput-notchedOutline': { 
                    borderColor: 'rgba(255, 255, 255, 0.2)' 
                  },
                  '& .MuiSelect-icon': { 
                    color: 'rgba(255, 255, 255, 0.7)' 
                  }
                }}
              >
                <MenuItem value="general">Rapport Général</MenuItem>
                <MenuItem value="clients">Analyse Clients</MenuItem>
                <MenuItem value="finances">Analyse Financière</MenuItem>
                <MenuItem value="reservations">Analyse Réservations</MenuItem>
                <MenuItem value="destinations">Analyse Destinations</MenuItem>
                <MenuItem value="custom">Rapport Personnalisé</MenuItem>
              </Select>
            </FormControl>
            
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel sx={{ 
                color: 'rgba(255, 255, 255, 0.7)',
                '&.Mui-focused': {
                  color: 'rgba(255, 255, 255, 0.9)'
                }
              }}>Format</InputLabel>
              <Select 
                value={exportFormat} 
                onChange={(e) => setExportFormat(e.target.value)} 
                label="Format"
                sx={{ 
                  color: 'white',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: 2,
                  '& .MuiOutlinedInput-notchedOutline': { 
                    borderColor: 'rgba(255, 255, 255, 0.2)' 
                  },
                  '& .MuiSelect-icon': { 
                    color: 'rgba(255, 255, 255, 0.7)' 
                  }
                }}
              >
                <MenuItem value="pdf">PDF</MenuItem>
                <MenuItem value="excel">Excel</MenuItem>
                <MenuItem value="csv">CSV</MenuItem>
              </Select>
            </FormControl>
            
            <FormControl fullWidth sx={{ mb: 2 }}>
              <Autocomplete
                options={clients}
                getOptionLabel={(option) => option.nom}
                value={selectedClient}
                onChange={(event, newValue) => {
                  setSelectedClient(newValue);
                }}
                renderInput={(params) => <TextField {...params} label="Filtrer par Client (optionnel)" InputLabelProps={{ style: { color: 'rgba(255, 255, 255, 0.7)' } }} sx={{ 
                  '& .MuiInputBase-root': { 
                    color: 'white',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: 2
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(255, 255, 255, 0.2)'
                  }
                }} />}
              />
            </FormControl>
            
            <FormControl fullWidth sx={{ mb: 2 }}>
              <Autocomplete
                options={destinations}
                getOptionLabel={(option) => option.nom}
                value={selectedDestination}
                onChange={(event, newValue) => {
                  setSelectedDestination(newValue);
                }}
                renderInput={(params) => <TextField {...params} label="Filtrer par Destination (optionnel)" InputLabelProps={{ style: { color: 'rgba(255, 255, 255, 0.7)' } }} sx={{ 
                  '& .MuiInputBase-root': { 
                    color: 'white',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: 2
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(255, 255, 255, 0.2)'
                  }
                }} />}
              />
            </FormControl>
            
            <Grid container spacing={2}>
              <Grid item xs={6}>
              <TextField
                  label="Date Début"
                type="date"
                value={dateRange.start}
                  onChange={(e) => setDateRange({ ...dateRange, start: e.target.value })}
                InputLabelProps={{ shrink: true, style: { color: 'rgba(255, 255, 255, 0.7)' } }}
                  fullWidth
                  sx={{ 
                    '& .MuiInputBase-root': { 
                      color: 'white',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      borderRadius: 2
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'rgba(255, 255, 255, 0.2)'
                    }
                  }}
              />
            </Grid>
              <Grid item xs={6}>
              <TextField
                  label="Date Fin"
                type="date"
                value={dateRange.end}
                  onChange={(e) => setDateRange({ ...dateRange, end: e.target.value })}
                InputLabelProps={{ shrink: true, style: { color: 'rgba(255, 255, 255, 0.7)' } }}
                  fullWidth
                  sx={{ 
                    '& .MuiInputBase-root': { 
                      color: 'white',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      borderRadius: 2
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'rgba(255, 255, 255, 0.2)'
                    }
                  }}
              />
            </Grid>
          </Grid>
                          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button 
            onClick={() => setOpenExportDialog(false)}
            sx={{
              color: 'white',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)'
              }
            }}
          >
            Annuler
          </Button>
          <Button
            variant="contained"
            onClick={handleExportReport}
            startIcon={isExporting ? <CircularProgress size={16} color="inherit" /> : <FileDownloadIcon />}
            disabled={isExporting}
            sx={{
              background: 'linear-gradient(135deg, #1e40af 0%, #7c3aed 100%)',
              color: 'white',
              fontWeight: 600,
              px: 3,
              py: 1,
              borderRadius: 2,
              boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
              '&:hover': {
                boxShadow: '0 6px 15px rgba(0,0,0,0.2)',
              }
            }}
          >
            {isExporting ? 'Exportation...' : 'Exporter'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Rapports; 